import React from "react"
import { getParams, end_point } from './helper'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons'
import { Row } from 'react-bootstrap'
import axios from 'axios'
import Tooltip from 'rc-tooltip'
import 'rc-tooltip/assets/bootstrap.css'

class NumericDisplay extends React.Component {
  constructor() {
    super()
    this.state = {
      token: getParams().jwt,
      organization_id: localStorage.getItem("organization_id"),
      data: [],
      get_monthly_transactions_endpoint: `${end_point()}/monthly_board`,
      values: {players: null, clubs: null, teams: null, grandTotal: null },
      visible: false
    }
  }

  async componentDidMount() {
    const url = this.state.get_monthly_transactions_endpoint
    console.log('URL=',url)
    let config = {
      headers : {
        "token": this.state.token,
        "organization_id": this.state.organization_id,
        "function": this.props.endpointFunction
      }
    }
    let response = await axios.get(url, config)
    console.log(' &&& NUMERIC DISPLAY - ', response.data.message)
    if (response.data) {
      this.setState({values: response.data.message})
    }
    console.log('&& STATE',this.state.values)

  }

  onVisibleChange = (visible) => {
    this.setState({visible})
  }

  render() {
      const { toggleSelection, toggleAll } = this;
      const { data } = this.state;

      return (
        <div style={{ display:"flex", justifyContent:"center", alignItems: 'center', flexDirection:"row"}} onClick={this.OnClick}>
          <div>
            <div style={{ display: "flex", flexDirection: "row", alignItems: 'flex-end'}}>
              <div style={{ marginBottom: "0px"}}>
                {/* <img src={this.props.icon} alt="calendar" style={{ height: '30px', width: '30px'}} />&nbsp;&nbsp; */}
              </div>
              <div>
                <h1>{this.state.values.grandTotal}</h1>
              </div>
              <div style={{float: "left"}}>
               <Tooltip
                  visible={this.state.visible}
                  animation="zoom"
                  placement="bottom"
                  onVisibleChange={this.onVisibleChange}
                  trigger="click"
                  overlayStyle={{width:"140px"}}
                  overlay={
                    <span>
                      <span style={{color:"#454545"}}><b>Enrolment Type</b><br></br></span>
                      <table style={{color:"#454545", tableLayout:"fixed"}}>
                      <span><br></br></span>
                      <tr><td style={{width:"50%"}}>Players</td><td style={{width:"10%"}}>{this.state.values.players}<br></br></td></tr>
                      <tr><td style={{width:"50%"}}>Teams</td><td style={{width:"10%"}}>{this.state.values.teams}<br></br></td></tr>
                      <tr><td style={{width:"50%"}}>Clubs</td><td style={{width:"10%"}}>{this.state.values.clubs}<br></br></td></tr>
                      </table>
                    </span>
                  }
                >
                  <a href="#" onClick={this.OnClick}>
                  {this.state.visible ?    <FontAwesomeIcon icon={faCaretUp} size="lg" color='#50B265' />   
                                               : <FontAwesomeIcon icon={faCaretDown} size="lg" color='#50B265' />}                
                  </a>
               </Tooltip>
              </div>                                       
            </div>
            <h4>{this.props.subTitle}</h4>
          </div>
        </div>
      )
  }
}

export default NumericDisplay
